export default __webpack_public_path__ + "static/media/logoo-blue.5b0e3141.svg";